<button
  mat-flat-button
  [disabled]="!!disabled()"
  [routerLink]="link() ?? undefined"
  (click)="onClick($event)"
  class="gray-button !h-8 sm:!h-10 max-sm:!text-[0.8rem] max-sm:!px-1 {{
    customClasses()
  }}"
  [ngClass]="{
    '!text-[#aaaaaa]': !!disabled(),
    ' !text-secondary-main': !disabled(),
    'w-full': fullWidth(),
  }"
>
  @if (icon()) {
    <mat-icon class="max-sm:!text-sm">{{ icon() }}</mat-icon>
  }
  {{ titleKey() ? (titleKey() || "" | translate) : title() }}
</button>
